export const DP_PRODUCT_RELATED_PARTS_FEATURE = 'dpProductRelatedPartsFeature';
